"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const material_1 = require("@mui/material");
const Check_1 = require("@mui/icons-material/Check");
const merge_1 = require("merge");
const checkbox_styles_1 = require("./checkbox.styles");
const CheckBox = ({ label, disabled, checked, checkBoxOverrides, textOverrides, formOverrides, iconOverrides, onClick, }) => {
    const styles = (0, checkbox_styles_1.default)({
        disabled,
        checked,
        label,
    });
    const handleClick = (e) => {
        if (disabled || !onClick)
            return;
        onClick(e);
    };
    return ((0, jsx_runtime_1.jsx)(material_1.ButtonBase, { "data-testid": "checkbox", onClick: handleClick, disableRipple: disabled, children: (0, jsx_runtime_1.jsxs)(material_1.Box, { sx: (0, merge_1.merge)(true, styles.form, formOverrides), children: [(0, jsx_runtime_1.jsx)(material_1.Box, { sx: (0, merge_1.merge)(true, styles.checkBox, checkBoxOverrides), children: (0, jsx_runtime_1.jsx)(Check_1.default, { sx: (0, merge_1.merge)(true, styles.icon, iconOverrides) }) }), (0, jsx_runtime_1.jsx)(material_1.Typography, { sx: (0, merge_1.merge)(true, styles.text, textOverrides), children: label })] }) }));
};
exports.default = CheckBox;
